import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectUserRbacPermissions } from 'core/userContext';
import { usePaginationContext } from 'utils/contexts/pagination';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import { SnippetRow } from './SnippetRow';
import { SnippetTableHeader } from './SnippetTableHeader';
import { SnippetListSkeleton } from './SnippetListSkeleton';
import { useSnippetQueryContext } from '../context/SnippetQueryContext';
import { GraphQLSnippet } from '../types';
import { getSnippetRowGrid } from '../utils';

export const SnippetTable = () => {
  const { isLoading, snippets: snippetList } = useSnippetQueryContext();
  const { pageSize } = usePaginationContext();
  const permissions = useSelector(selectUserRbacPermissions);
  const canManageSnippets = useMemo(
    () => permissions.includes(PROJECT_PERMISSIONS.ManageSnippets),
    [permissions],
  );
  const snippetRowGrid = getSnippetRowGrid(canManageSnippets);

  const snippetSkeletons = Array(pageSize)
    .fill({})
    .map((skeleton, i) => (
      <SnippetListSkeleton
        key={`skeleton-${i}`}
        canManageSnippets={canManageSnippets}
        snippetRowGrid={snippetRowGrid}
      />
    ));

  return (
    <div data-test="snippet-table">
      <SnippetTableHeader />
      {isLoading
        ? snippetSkeletons
        : snippetList.map((snippet: GraphQLSnippet) => {
            return (
              <SnippetRow
                canManageSnippets={canManageSnippets}
                key={`snippet-${snippet.id}`}
                snippet={snippet}
                snippetRowGrid={snippetRowGrid}
              />
            );
          })}
    </div>
  );
};
